/**
 * Test drive permits linking to micro-frontends via query parameter.
 * The query parameter is persisted in local storage, so page navigation
 * continues to use the override version.
 *
 * Clearing the override can be done via the import-map-override UI.
 */

(async () => {
  const search = new URLSearchParams(window.location.search);
  const imoLocalStorageRaw = search.get('imoLocalStorage');
  if (imoLocalStorageRaw) {
    const imoLocalStorage = JSON.parse(imoLocalStorageRaw);
    const overrides = Object.entries<string>(imoLocalStorage.imports);
    overrides.forEach(([key, value]) => {
      const { hostname } = new URL(value);
      /* 🚨 Only permit overrides from trusted hostnames 🚨 */
      if (hostname === 'cdn.zuora.com') {
        window.localStorage.setItem(`import-map-override:${key}`, value);
      }
    });
    const newLocation = new URL(document.location.href);
    search.delete('imoLocalStorage');
    newLocation.search = search.toString();
    window.location.href = newLocation.href;
  }
})();
